import { Link } from "react-router-dom";
import JobKeyLogo from "@/components/JobKeyLogo";
import LangSelect from "@/components/LangSelect";
import { useI18n } from "@/i18n";

export default function Contact() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-bg">
      <header className="border-b border-line/60 bg-surface">
        <div className="mx-auto flex h-16 max-w-3xl items-center justify-between px-5">
          <Link to="/" data-testid="contact-logo"><JobKeyLogo /></Link>
          <div className="flex items-center gap-4">
            <LangSelect />
            <Link to="/" className="text-sm font-bold text-accent">{t("Back home")}</Link>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-5 py-14" data-testid="contact-page">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted">{t("Contact")}</p>
        <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight">{t("Talk to us")}</h1>
        <div className="mt-8 grid gap-4">
          <div className="rounded-2xl border border-line bg-surface p-6" data-testid="contact-support-card">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted">{t("Support")}</p>
            <p className="mt-2 font-bold">support@jobky.in</p>
            <p className="mt-1 text-sm text-muted">{t("Replies within 1 working day.")}</p>
          </div>
        </div>
        <div className="mt-8 rounded-2xl border border-line bg-surface p-6">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted">{t("Before you write")}</p>
          <ul className="mt-3 space-y-2 text-sm text-muted">
            <li>· {t("· Billing questions: see the Billing page for invoices and your wallet ledger.")}</li>
            <li>· {t("· Password problems: use \"Forgot password\" on the login screen.")}</li>
            <li>· {t("· Feature requests and bug reports: include your account email and a screenshot.")}</li>
          </ul>
        </div>
      </main>
    </div>
  );
}
